<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/rhythm/pic01.jpg" alt="איך מצטרפים?" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
						<div class="textbox-tab-mark""></div>
<div id="origamiform" data-origamiformname="form_6040df97af7c3" data-origamiformid="ece4e756c0add3a98a85164e88ce02b980116bd9b93c5ca9447837e27e5e5e7a99273ad63fe22b424900362f49259d3bacdeac82d57bda0f7941f0e3626a4d56MIuvoqrDDj+U6xEnUB1EQGhd6mRUIaszNfyGHknlMNmYmuWosQZXxAooel7jTJKSYKiJyL9L1kQURkrLIRpTM47po1iI7DdwTq0wFiLFlMebxaVdUf8/7+Zq4mWzrb8Q" ></div>
						<div class="textbox-text">
							
						</div>
					
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			
		</section>
  </main-layout>
</template>
<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Origami.vue'
   import VLink from '../components/VLink.vue'
  import VueScrollTo from 'vue-scrollto'

/* eslint-disable no-useless-escape */
import postscribe from 'postscribe'

  export default {
  mounted:function(){
    postscribe('#origamiform', '<script src="https://public.origamicloud.ms/web_forms/js"><\/script>')
    postscribe('#origamiform', '<script type="text/javascript"> ORIGAMI_FORMS["form_6040df97af7c3"] = { "fields": { "Lead_First_name" : { "value" : "testing", "hidden" : true }, }, "rtl": "1" };  <\/script>')
  },
    components: {
      MainLayout,VLink
    },
	created () {
		this.texts = {}
	},
	ready:function(){
    },
	data() {
		return {
		}
	},
	watch: {

		
	},
	methods: {
		scrollToFooter(){
			this.$scrollTo(".credits", 0, {})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// SubscriptionRequest.vue?4c53b423